"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var prosemirror_state_1 = require("prosemirror-state");
var event_1 = require("../../event");
var state_1 = require("../../state");
var pluginKey = new prosemirror_state_1.PluginKey('lifecycle');
var emitLifeCycleEvent = function (view, prevState, emitter) {
    var state = view.state;
    if (!prevState.doc.eq(state.doc)) {
        // TODO 由于诸如react，vue等库更新DOM的时机并不是顺序的，而是统一渲染，造成渲染时机延后，导致如果同步获取的HTML会获取到上一次的数据
        setTimeout(function () { return emitter.emit(event_1.EventChannel.LocalEvent.TEXT_CHANGED, new state_1.SylState(state)); });
    }
    if (!prevState.selection.eq(state.selection)) {
        emitter.emit(event_1.EventChannel.LocalEvent.SELECTION_CHANGED, new state_1.SylState(state));
    }
};
exports.emitLifeCycleEvent = emitLifeCycleEvent;
var LifeCyclePlugin = /** @class */ (function (_super) {
    __extends(LifeCyclePlugin, _super);
    function LifeCyclePlugin(editor) {
        var _this = _super.call(this, {
            key: pluginKey,
            view: function () {
                return {
                    update: function (view, prevState) { return emitLifeCycleEvent(view, prevState, _this.emitter); }
                };
            }
        }) || this;
        _this.emitter = editor.configurator.configuration.emitter;
        return _this;
    }
    return LifeCyclePlugin;
}(prosemirror_state_1.Plugin));
var createLifeCyclePlugin = function (editor) { return new LifeCyclePlugin(editor); };
exports.createLifeCyclePlugin = createLifeCyclePlugin;
//# sourceMappingURL=lifecycle-plugin.js.map